//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TopLevelTag from '../common/TopLevelTag.vue';
export default {
  props: {
    list: {
      type: Array,
      default: []
    },
    isAbTest: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TopLevelTag: TopLevelTag
  },
  mounted: function mounted() {
    var scrollEl = document.getElementById('top-scroll-view-stats');
    scrollEl.addEventListener('scroll', window.StatusReportData, false);
  },
  methods: {
    goToTopList: function goToTopList() {
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_394nf0f8_mc',
        cid: 'c_movie_aq5xt2v5'
      });
      this.go("/topList", {
        _blank: true
      });
    },
    goToTop: function goToTop(id) {
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_eg318qa6_mc',
        cid: 'c_movie_aq5xt2v5'
      });
      this.go("/top/".concat(id, "?type=1"), {
        _blank: true
      });
    },
    handleClick: function handleClick(project) {
      var _ref = project || {},
          performanceId = _ref.performanceId;

      if (!performanceId) return;

      if (project.dataSeed) {
        window.seedAction(project.dataSeed);
      }

      this.go("/detail/".concat(performanceId), {
        _blank: true
      });
    }
  }
};